"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var Utility_1 = require("../../Icons/Utility");
var styles_1 = __importDefault(require("./styles"));
var classnames_1 = __importDefault(require("classnames"));
var useStyles = (0, react_jss_1.createUseStyles)(styles_1.default);
// eslint-disable-next-line no-redeclare
var Alert = function (_a) {
    var title = _a.title, description = _a.description, variant = _a.variant, children = _a.children, className = _a.className, _b = _a.collapsed, collapsed = _b === void 0 ? false : _b;
    var classes = useStyles({ variant: variant });
    var _c = (0, react_1.useState)(!collapsed), open = _c[0], setOpen = _c[1];
    var isdanger = variant === 'danger';
    var iconColor = isdanger ? 'white' : 'gray500';
    var ExpandIcon = open ? Utility_1.ExpandLess : Utility_1.ExpandMore;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(classes.root, className), onClick: function () { return setOpen(!open); } },
        react_1.default.createElement(Utility_1.AlertWarning, { ariaHidden: true, color: iconColor, size: "large", className: classes.icon }),
        react_1.default.createElement("div", { className: classes.body },
            react_1.default.createElement("p", { className: classes.title }, title),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(classes.description, { closed: !open }) },
                description && react_1.default.createElement("p", null, description),
                children)),
        react_1.default.createElement("div", null,
            react_1.default.createElement(ExpandIcon, { ariaHidden: true, color: iconColor, size: "large" }))));
};
exports.default = Alert;
